<template>
  <FormesSuperposees/>
</template>

<script>
// @ is an alias to /src
import FormesSuperposees from '@/components/formes-superposees/FormesSuperposees.vue'

export default {
  name: 'FormesSuperposeesPage',
  components: {
    FormesSuperposees
  }
}
</script>
